var MapsProviderEnum = /* @__PURE__ */ ((MapsProviderEnum2) => {
  MapsProviderEnum2["Google"] = "google";
  MapsProviderEnum2["Yandex"] = "yandex";
  return MapsProviderEnum2;
})(MapsProviderEnum || {});
export {
  MapsProviderEnum
};
//# sourceMappingURL=Map.types.js.map
